module.exports = __webpack_public_path__ + "static/media/left-arrow.aaf34fe7.svg";